// src/components/OrderTracking.js
import React, { useEffect,useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Layout, Typography, Row, Col, Divider, Space, Steps, Tooltip, Spin, Alert, Button } from 'antd';
import { EnvironmentOutlined, PhoneOutlined, CarOutlined, HomeOutlined } from '@ant-design/icons';
import { FaUtensils, FaHome, FaCarAlt } from 'react-icons/fa';
import { fetchOrder,createPayment } from '../../redux/actions/orderActions';
import logo from '../../assets/logo2.png'; // Ensure you have a logo in your assets folder
import AppCounter from '../../components/appCounter';
import NotFound from './notFound';
import TrackingMap from '../../components/map';
import { useLocation } from 'react-router-dom';
import formatDate from '../../helper/dateHelper'
import {LoadingOutlined} from '@ant-design/icons';
import deliveryStatus from '../../helper/orderStatus';
import orderStatus from '../../helper/orderStatus';

const { Header, Content } = Layout;
const { Title, Text } = Typography;
const { Step } = Steps;

const OrderTracking = () => {
  const dispatch = useDispatch();
  const orderState = useSelector((state) => state.order);
  const { loading, order, error,driver } = orderState;
  const location = useLocation();
  const [step, setStep] = useState(0);
  const [paymentClicked,setPaymentClicked] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    var orderId= params.get('orderid');
    dispatch(fetchOrder(orderId)); // Replace '123' with actual order ID
  }, [dispatch]);

  useEffect(() => {
    if(order==null){
      setStep(0);
      return ;
    }
    if(paymentClicked){
      if(order.paymentMethodId == 10){
        if(order.paymentUrl!=null){
          window.location.href = order.paymentUrl;
        }
      }

    }
    if(order.deliveryStatusId == deliveryStatus.PENDING)
      {
        setStep(0);
      }
    else if(order.deliveryStatusId == deliveryStatus.PICKED 
      || order.deliveryStatusId == deliveryStatus.STARTED_TRACKING 
      || order.deliveryStatusId == deliveryStatus.REACHED_CUSTOMER 
      | order.deliveryStatusId == deliveryStatus.REACHED_STORE ||
      order.deliveryStatusId == deliveryStatus.ACCEPTED )
      {
        setStep(1);
      }
    else if(order.deliveryStatusId == deliveryStatus.DELIVERED)
      {
        setStep(2);
      }
  }, [order]);

  // if (loading) {
  //   return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} />;
  // }

  // if (error) {
  //   return (
  //     <NotFound/>
  //   )
  // }
 
  return (
     order==null ? <Spin size="large" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} /> :
    <Layout className="tracking-layout">
      <div className="tracking-header">
        <div className="header-content">
          <img src={logo} alt="Logo" className="logo" />
          <Title level={4} className="header-title">Order Tracking</Title>
          {order.deliveryStatusId != deliveryStatus.DELIVERED && <AppCounter />}
        </div>
      </div>
      
      <div className="map-wrapper">
        <TrackingMap order={order} driver={driver} />
      </div>

      <Content className="tracking-content-container">
        <div className="modern-card tracking-card animated-slide-up">
          
          <div className="amount-header">
            <Col>
              <Title level={3} style={{ margin: 0, color: '#D81F51' }}>{order?.totalAmount} KWD</Title>
              <Text type="secondary">{order?.paymentMethod}</Text>
            </Col>
            <Col>
            {order.paymentMethodId == 10 && order.deliveryStatusId != deliveryStatus.CANCLED && (
              <Button type="primary" className="pay-btn" size="large" onClick={() => {
                setPaymentClicked(true);
                dispatch(createPayment({
                  orderId: order.id,
                  totalAmount: order.totalAmount,
                }))
              }}>Pay Online</Button>
            )}
            </Col>
          </div>

          <Divider style={{ margin: '16px 0' }} />

          <Steps direction="vertical" current={step} className="custom-steps modern-steps">
            <Step 
              title={
                <Tooltip title={formatDate(order.promisedDeliveryDateUtc)}>
                  <span className="step-title">Order Placed</span>
                </Tooltip>
              } 
              description={
                <Space direction="vertical" size={0}>
                  <Text strong>{order.client.nameEn}</Text>
                  <Text className="text-muted">{order.clientLocation.locationAddress.addressLine1}</Text>
                  <Text type="secondary" style={{ fontSize: '12px' }}>{formatDate(order.promisedDeliveryDateUtc)}</Text>
                </Space>
              } 
              icon={<EnvironmentOutlined className="step-icon" />} 
            />
            <Step 
              title={
                <Tooltip title={order?.pickedTime}>
                  <span className="step-title">Order Status </span>
                </Tooltip>
              } 
              description={
                order.driver ? (
                  <>
                  <Text strong>{orderStatus.getStatusMessage(order)}...</Text>
                  {order.deliveryStatusId != deliveryStatus.DELIVERED && <LoadingOutlined style={{ marginLeft: 8 }} />}
                  <br/>
                  <Space direction="vertical" size={0} style={{ marginTop: '8px' }}>
                    <Text type="secondary">Driver Assigned</Text>
                  </Space>
                  </>
                ) : 
                  <>
                  <Text>{orderStatus.getStatusMessage(order)}</Text>
                  <LoadingOutlined style={{ marginLeft: 8 }} />
                  </>
                 
              } 
              icon={<CarOutlined className="step-icon" />} 
            />
            <Step 
              title={
                <Tooltip title={`ETA: ${order?.ETA}`}>
                  <span className="step-title">Destination</span>
                </Tooltip>
              } 
              description={
                <Space direction="vertical" size={0}>
                  <Text strong>{order.customerFirstName} {order.customerLastName}</Text>
                  <Text className="text-muted">{order.customerAddress.addressLine1}</Text>
                </Space>
              } 
              icon={<HomeOutlined className="step-icon" />} 
            />
          </Steps>
          
          {order.driver && (
            <div className="driver-info-card">
              <Row align="middle" gutter={16}>
                <Col>
                  <div className="driver-avatar">
                    <FaCarAlt size={28} color="#fff" />
                  </div>
                </Col>
                <Col flex="auto">
                  <Space direction="vertical" size={0}>
                    <Text strong style={{ fontSize: '16px' }}>{order?.driver.firstName} {order?.driver.lastName}</Text>
                    <Text type="secondary" style={{ fontSize: '13px' }}>Your Driver</Text>
                  </Space>
                </Col>
                <Col>
                  {order?.driver?.mobile && (
                    <a href={`tel:${order.driver.mobile}`} className="call-driver-btn">
                      <PhoneOutlined />
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          )}

        </div>
      </Content>
    </Layout>
  );
};

export default OrderTracking;
